import Splide from '@splidejs/splide';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      if ( $( '.process-steps' ).length ) {
        $( '.process-steps' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            perPage: 2,
            pagination: false,
            perMove: 1,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );
          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
            }
          } );
          slider.mount();

          const dividerEl = element.querySelector( '.process-steps__divider' );

          if ( dividerEl ) {
            if ( !window.hasMotion ) {
              dividerEl.style.setProperty( '--process-steps-divider-scale', 1 );
              return;
            }

            gsap.set( dividerEl, {
              '--process-steps-divider-scale': 0,
            } );

            gsap.to( dividerEl, {
              '--process-steps-divider-scale': 1,
              'duration': 1,
              'delay': 0.75,
              'ease': 'power2.out',
              'scrollTrigger': {
                trigger: dividerEl,
                start: 'top 85%',
                once: true,
              },
            } );
          }

          const arrows = element.querySelector( '.process-steps__arrows' );

          if ( arrows ) {
            gsap.set( arrows, {
              autoAlpha: 0,
              y: 20,
            } );

            ScrollTrigger.create( {
              trigger: element,
              start: 'top 85%',
              once: true,
              onEnter: () => {
                gsap.to( arrows, {
                  autoAlpha: 1,
                  y: 0,
                  duration: 0.6,
                  delay: window.innerWidth >= 1024 ? 1.75 : 0,
                  ease: 'power2.out',
                } );
              },
            } );
          }
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'process-steps', COMPONENT );
} )( app );
